<template>
  <b-modal
    :id="modalId"
    modal-class="modal-fullscreen"
    size="lg"
    scollable
    hide-header
    @hide="handleHide"
  >
    <div class="header__tools">
      <span v-if="v2" class="ico ico__search" title="Search Tool">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.85406 19.7087C4.39643 19.7087 0 15.3122 0 9.85437C0 4.39656 4.39643 0 9.85406 0C15.3117 0 19.7081 4.39656 19.7081 9.85437C19.7081 15.3122 15.3117 19.7087 9.85406 19.7087ZM9.85406 1.51606C5.23023 1.51606 1.51601 5.2304 1.51601 9.85437C1.51601 14.4783 5.23023 18.1927 9.85406 18.1927C14.4779 18.1927 18.1921 14.4783 18.1921 9.85437C18.1921 5.2304 14.4779 1.51606 9.85406 1.51606Z"
            fill="black"
            fill-opacity="0.5"
          />
          <path
            d="M17.1932 16.1211L24 22.9282L22.9282 24L16.1213 17.1929L17.1932 16.1211Z"
            fill="black"
            fill-opacity="0.5"
          />
        </svg>
      </span>
      <h3> {{ tileName }} Management</h3>
      <span class="ico" @click="handleDismissClickWithType('x')">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="16" cy="16" r="16" fill="#E4E6EB" />
          <g clip-path="url(#clip0)">
            <path
              d="M16.7855 16.0008L22.9482 9.83807C23.1652 9.6211 23.1652 9.26932 22.9482 9.05238C22.7312 8.83543 22.3794 8.83541 22.1625 9.05238L15.9998 15.2151L9.83709 9.05238C9.62012 8.83541 9.26834 8.83541 9.0514 9.05238C8.83446 9.26935 8.83443 9.62113 9.0514 9.83807L15.2141 16.0008L9.0514 22.1635C8.83443 22.3804 8.83443 22.7322 9.0514 22.9492C9.15987 23.0576 9.30207 23.1119 9.44426 23.1119C9.58646 23.1119 9.72862 23.0576 9.83712 22.9492L15.9998 16.7865L22.1625 22.9492C22.2709 23.0576 22.4131 23.1119 22.5553 23.1119C22.6975 23.1119 22.8397 23.0576 22.9482 22.9492C23.1652 22.7322 23.1652 22.3804 22.9482 22.1635L16.7855 16.0008Z"
              fill="#606770"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="14.2222"
                height="14.2222"
                fill="white"
                transform="translate(8.88867 8.88892)"
              />
            </clipPath>
          </defs>
        </svg>
      </span>
    </div>
    <b-row v-if="!tileKey">
      <b-col>
        <b-form-group label-for="input-6" class="custom-label">
          <label-info
            id="popover-target-exercise-level"
            label-name="Category"
            label-info="The Level that you are now"
          />
          <b-dropdown
            id="dropdown-1"
            class="m-md-2"
            block
            split
            split-variant="outline-primary"
            variant="primary"
          >
            <template #button-content>
              <span v-if="selectedCatEntryForAdd">
                <template
                  v-if="
                    Array.isArray(selectedCatEntryForAdd) &&
                      selectedCatEntryForAdd.length == 2 &&
                      selectedCatEntryForAdd[1]
                  "
                >
                  <b-img
                    v-if="selectedCatEntryForAdd[1].imgURL"
                    :src="selectedCatEntryForAdd[1].imgURL"
                    v-bind="mainProps"
                    :alt="selectedCatEntryForAdd[1].name"
                  />
                  {{ selectedCatEntryForAdd[1].name }}
                </template>
              </span>
              <strong v-else>
                Select Category
              </strong>
            </template>
            <b-dropdown-item
              v-for="(aCategoryEntry, i) in availCategoryEntries"
              aria-describedby="dropdown-header-label"
              @click="handleCatButtonClick(aCategoryEntry)"
              :key="`cat_${i}`"
            >
              <template
                v-if="
                  Array.isArray(aCategoryEntry) &&
                    aCategoryEntry.length == 2 &&
                    aCategoryEntry[1]
                "
              >
                <b-img
                  v-if="aCategoryEntry[1].imgURL"
                  :src="aCategoryEntry[1].imgURL"
                  v-bind="mainProps"
                  alt="Top-rounded image"
                />
                {{ aCategoryEntry[1].name }}
              </template>
            </b-dropdown-item>
          </b-dropdown>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label-for="input-6" class="custom-label">
          <label-info
            id="popover-target-exercise-level"
            label-name="Tile"
            label-info="The Level that you are now"
          />
          <b-dropdown
            id="dropdown-tile"
            class="m-md-2"
            block
            split
            split-variant="outline-primary"
            variant="primary"
            :disabled="!selectedCatEntryForAdd"
          >
            <template #button-content>
              <span v-if="selectedTileForAdd">
                {{ selectedTileForAdd.name }}
              </span>
              <strong v-else>
                Select Tile
              </strong>
            </template>
            <b-dropdown-item
              v-for="(aTileOption, i) in tileOptions"
              aria-describedby="dropdown-header-label"
              @click="handleTileButtonClick(aTileOption)"
              :key="`tile_${i}`"
            >
              {{ aTileOption.name }}
            </b-dropdown-item>
          </b-dropdown>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="body__tools">
      <b-tabs pills card>
        <b-tab title="Manual" active>
          <div v-if="manualForm">
            <!-- DATE  -->
            <b-form-group
              label="Date"
              :label-for="`input-entry-date`"
              class="custom-label"
              description="The date of the data"
            >
              <b-form-datepicker
                id="entry-date"
                v-model="form._tracking_date_at"
                class="mb-2"
                :min="trackingDateMin"
                :max="trackingDateMax"
                locale="en"
              />
            </b-form-group>

            <!--- TIME -->
            <b-form-group
              v-if="manualForm.hasTime"
              label="Time"
              :label-for="`input-entry-date`"
              class="custom-label"
              description="The date of the dta"
            >
              <b-form-timepicker
                  v-model="form._tracking_time_at"
                  locale="en"
              />
            </b-form-group>

            <!--- FIELDS -->
            <template
              v-if="manualForm.fields && Array.isArray(manualForm.fields)"
            >
              <div v-for="(aField, i) in manualForm.fields" :key="`mf_${i}`">
                <b-form-group
                  :label="aField.name"
                  :label-for="`input-${aField.field}`"
                  class="custom-label"
                  :description="aField.description"
                >
                  <b-input-group>
                    <b-form-input
                      v-model.trim="form.fields[aField.field]"
                      trim
                      class="custom-input"
                      :placeholder="aField.placeholder"
                      :type="aField.type"
                    >
                    </b-form-input>
                    <template v-if="aField.append" #append>
                      <b-input-group-text>{{
                        aField.append
                      }}</b-input-group-text>
                    </template>
                  </b-input-group>
                </b-form-group>
              </div>
            </template>

            <!-- NOTE -->
            <div v-if="manualForm.hasNote">
              <b-form-group
                id="input-group-1"
                label="Notes:"
                label-for="input-1"
                description="Give more detail"
              >
                <transition name="fadeHeight" mode="out-in">
                  <editor
                    id="textarea-default"
                    v-show="form"
                    @input="editorInput"
                    :clear="editorClear"
                    :content="form.note"
                    @resetClear="editorResetClear"
                  />
                </transition>
              </b-form-group>
            </div>
          </div>
          <b-card-text v-else>
            <templat v-if="tileKey">
              Manual Entry is not available for {{ tileName }}.
            </templat>
            <template v-else>
              Image for adding tiles
            </template>
          </b-card-text>
        </b-tab>
        <b-tab title="Connected">
          <div
            v-if="
              connectedDevices &&
                Array.isArray(connectedDevices) &&
                connectedDevices.length > 1
            "
          >
            <div
              v-for="(aConnection, j) in connectedDevices"
              :key="`connection_${j}`"
            >
              <b-button
                pill
                class="btn-add-crew"
                @click="handleConnectionClick(aConnection)"
                style="margin-bottom: 20px"
                variant="primary"
              >
                {{ aConnection.text }}
              </b-button>
            </div>
          </div>
          <b-card-text v-else>
            No connections are available for {{ tileName }}. Add connected
            devices for heartbeat under "My Profile".
          </b-card-text>
        </b-tab>
        <b-tab title="Graph Data">
          <div
              v-if="
              connectedDevices &&
                Array.isArray(connectedDevices) &&
                connectedDevices.length > 1
            "
          >
            <div
                v-for="(aConnection, j) in connectedDevices"
                :key="`connection_${j}`"
            >
              <b-button
                  pill
                  class="btn-add-crew"
                  @click="handleConnectionClick(aConnection)"
                  style="margin-bottom: 20px"
              >
                {{ aConnection.text }}
              </b-button>
            </div>
          </div>
          <b-card-text v-else>
            No connections are available for {{ tileName }}. Add connected
            devices for heartbeat under "My Profile".
          </b-card-text>
        </b-tab>
        <b-tab title="Goals">
          <div
              v-if="
              connectedDevices &&
                Array.isArray(connectedDevices) &&
                connectedDevices.length > 1
            "
          >
            <div
                v-for="(aConnection, j) in connectedDevices"
                :key="`connection_${j}`"
            >
              <b-button
                  pill
                  class="btn-add-crew"
                  @click="handleConnectionClick(aConnection)"
                  style="margin-bottom: 20px"
              >
                {{ aConnection.text }}
              </b-button>
            </div>
          </div>
          <b-card-text v-else>
            No connections are available for {{ tileName }}. Add connected
            devices for heartbeat under "My Profile".
          </b-card-text>
        </b-tab>
      </b-tabs>
    </div>
    <template #modal-footer>
      <b-button
        pill
        class="btn-add-crew"
        @click="handleSaveClick"
        style="margin-bottom: 20px"
        variant="warning"
      >
        Save
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import tilesJSON from "@/assets/heartbeat/tiles.json";
import LabelInfo from "@/components/common/labelInfo";
import Editor from "@/components/common/editor";
export default {
  name: "HeartBeat_Tile_Modal",
  components: {
    LabelInfo,
    Editor
  },
  props: {
    modalId: {
      type: String,
      required: false,
      default: () => {}
    },
    profile: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    },
    heartbeat: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    },
    tileKey: {
      type: String,
      required: false,
      default: "weight"
    },
    categoryEntries: {
      type: Array,
      required: false,
      default: () => {
        return [];
      }
    },
    tileEntries: {
      type: Array,
      required: false,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    ...mapGetters({}),
    profileBy() {
      return {
        uid: this.profile && this.profile.userId ? this.profile.userId : null,
        name: this.profile
          ? `${this.profile.firstname ? this.profile.firstname : null} ${
              this.profile.lastname ? this.profile.lastname : null
            }`
          : null,
        imgURL: this.profile && this.profile.imgURL ? this.profile.imgURL : null
      };
    },
    tileTPL() {
      let theTile =
        this.tileEntries && Array.isArray(this.tileEntries) && this.tileKey
          ? this.tileEntries.filter(aTile => {
              return aTile.key === this.tileKey;
            })
          : null;
      return theTile && Array.isArray(theTile) && theTile[0]
        ? theTile[0]
        : null;
    },
    currTileDatum() {
      return this.tileData[this.currIdx];
    },
    tileOptions() {
      // return this.selectedCatEntryForAdd[1].tiles;
      return Array.isArray(this.selectedCatEntryForAdd) &&
        this.selectedCatEntryForAdd.length == 2 &&
        this.selectedCatEntryForAdd[1] &&
        this.selectedCatEntryForAdd[1].tiles &&
        Array.isArray(this.selectedCatEntryForAdd[1].tiles)
        ? this.selectedCatEntryForAdd[1].tiles
        : [];
    },
    manualForm() {
      if (this.tileKey && this.tileTPL) {
        return this.tileTPL.types && this.tileTPL.types.manual
          ? this.tileTPL.types && this.tileTPL.types.manual
          : {};
      }
      return this.selectedTileForAdd &&
        this.selectedTileForAdd.types &&
        this.selectedTileForAdd.types.manual
        ? this.selectedTileForAdd.types.manual
        : null;
    },
    tileName() {
      if (this.tileKey) {
        let theTile =
          this.tileEntries && Array.isArray(this.tileEntries)
            ? this.tileEntries.filter(aTile => {
                return aTile.key === this.tileKey;
              })
            : null;

        return theTile &&
          Array.isArray(theTile) &&
          theTile[0].hasOwnProperty("name")
          ? theTile[0].name
          : this.tileKey
          ? this.tileKey[0].toUpperCase() + this.tileKey.slice(1)
          : "";
      } else if (this.selectedTileForAdd && this.selectedTileForAdd.name) {
        return this.selectedTileForAdd.name;
      }
      return "New Tile";
    }
  },
  beforeMount() {
    this.modalReset();
  },
  mounted() {},
  methods: {
    handleCatButtonClick(categoryEntry) {
      this.selectedCatEntryForAdd = categoryEntry;
      this.selectedTileForAdd = null;
    },
    handleTileButtonClick(tileOption) {
      this.selectedTileForAdd = tileOption;
    },
    modalReset() {
      this.selectedCatEntryForAdd = null;
      this.selectedTileForAdd = null;
      this.form = null;
      this.form = _.clone(this.formDefault);

      //Init Values
      this.form._tracking_date_at = this.trackingDateInit;
      this.form._tracking_time_at = this.trackingTimeInit;
    },
    handleModalToggle() {
      this.modalShow = !this.modalShow;
    },
    handleDismissClickWithType(type) {
      this.modalReset();
      this.$bvModal.hide(this.modalId);
    },
    handleHide(){
      this.modalReset();
      this.$bvModal.hide(this.modalId);
    },
    handleConnectionClick(connectedDevice) {
      alert(connectedDevice.siteURL);
      //check if they have the devic or send email
    },
    editorInput(val) {
      this.form.note = val.content;
    },
    editorResetClear() {
      this.editorClear = false;
    },
    handleSaveClick() {
      debugger;

      let name = 'Tile';
      let key = 'tile';

      if (this.tileKey) {
        key = this.tileKey;
      }else
      {
        name = this.selectedTileForAdd.name;
        key = this.selectedTileForAdd.key;
      }

      this.$store
        .dispatch("heartbeats/addUpdateTile", {
          heartbeat: this.heartbeat ? this.heartbeat : null,
          tileKey: key,
          tileObj: this.form,
          createdBy: this.profileBy
        })
        .then(() => {
          this.$store.dispatch("user/showNotification", {
            title: `${name} Saved`,
            description: `${name} has been saved.`,
            variant: "success"
          });
          this.$emit("tile-added", this.form);
          this.handleDismissClickWithType(`added_${key}`);
        });
    }
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    // 15th two months prior
    const minDate = new Date(today);
    minDate.setMonth(minDate.getMonth() - 2);
    minDate.setDate(15);
    // 15th in two months
    const maxDate = new Date(today);
    maxDate.setMonth(maxDate.getMonth());
    maxDate.setDate(0);
    return {
      availCategoryEntries: this.categoryEntries.filter((aCategoryEntry) => {
        return Array.isArray(aCategoryEntry) && aCategoryEntry[1]
            && aCategoryEntry[1].isAvail === true;
      }),
      trackingDateInit: today,
      trackingDateMin: minDate,
      trackingDateMax: maxDate,
      trackingTimeInit: new Date().toTimeString().slice(0, 8),
      v2: false,
      tilesJSON,
      selectedCatEntryForAdd: null,
      selectedTileForAdd: null,
      form: null,
      editorClear: false,
      formDefault: {
        _created_at: null,
        _tracking_date_at: "",
        _tracking_time_at: null,
        note: [],
        fields: {}
      },
      connectedDevices:
        this.tile && this.tile.types && this.tile.types.connections
          ? this.tile.types.connections
          : null,
      mainProps: {
        blank: false,
        width: 25,
        height: 25,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.header__tools {
  position: relative;
  padding-bottom: 8px;
  &.border-none::after {
    content: none !important;
  }
  .ico {
    position: absolute;
    top: 5px;
    right: 13px;
    cursor: pointer;
  }
  .ico__search {
    right: unset !important;
    left: 13px;
  }
  h3 {
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    line-height: 49px;
    text-align: center;

    color: #5b606c;
  }
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    width: 100%;
  }
}
.modal-fullscreen .modal-dialog {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
}

.body__tools {
  height: 100%;
  .filter {
    display: flex;
    align-items: center;
    margin-top: 20px;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #5b606c;
      width: 160px;
      margin: 0;
    }
    .filters {
      height: 45px;
      display: flex;
      align-items: center;
      max-width: 100%;
      overflow-x: scroll;
      &::-webkit-scrollbar {
        height: 0px;
        margin-right: 10px;
      }

      &::-webkit-scrollbar-track {
        background-color: #fff;
      }

      &::-webkit-scrollbar-thumb {
        background: #dddddd;
        // border-radius: 16px;
      }
      .filter_ {
        cursor: pointer;
        padding: 8px 16px;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        background-color: #fff;
        color: #5b606c;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
        border-radius: 32px;
        margin-right: 16px;
        &.active {
          background: rgba(85, 126, 251, 0.1);
          color: var(--theme-color);
          box-shadow: none;
        }
      }
    }
  }
  .tool__wrapper {
    padding: 32px 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 24px 12px;
    max-height: 530px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 5px;
      margin-right: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {
      background: #dddddd;
      border-radius: 16px;
    }
  }
  .tool {
    cursor: pointer;
    position: relative;
    border-radius: 5px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .tool-event {
      padding: 18px;
      & > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    .video {
      position: absolute;
      top: 22px;
      right: 18px;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #474d52;
      margin-top: 10px;
      margin-bottom: 0;
    }
    h4 {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      color: #000000;
      margin-bottom: 0;
      margin-left: 10px;
    }
    .left {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .check {
      display: none;
    }
    &.active {
      .check {
        display: block !important;
      }
      .video {
        display: none !important;
      }
      background-color: #e8eaf9;
    }
  }
  .description__wraper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: column;
    img {
      margin-bottom: 34px;
      height: 48px;
      width: 48px;
    }
    h3 {
      font-style: normal;
      font-weight: bold;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin-bottom: 34px;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;

      color: #5b606c;
    }
    .btn-add-crew {
      margin-top: 80px;
      margin-bottom: 30px;
    }
  }
}

.tool-image {
  width: 50px;
}

@media (max-width: 520px) {
  .body__tools {
    grid-template-columns: 1fr !important;
  }
}
</style>
